import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=276437e2&scoped=true"
import script from "./AddContactDialog.vue?vue&type=script&lang=ts"
export * from "./AddContactDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276437e2",
  null
  
)

export default component.exports